import React from 'react';

export default function Card(props) {
  return (
    <div className="card app-card mb-4">
      { props.title ? (<h3 className="card-header app-card-title">{props.title}</h3>) : ('')
      }
      <div className="card-body">
        {props.children}
      </div>
    </div>
  );
}
